import { useFlags } from 'launchdarkly-react-client-sdk';

import { FEATURE_FLAGS } from 'constants/chownow';
import { RESTAURANT_ORDERS_AGGREGATION } from 'scopes/scopes';
import { useAuth } from 'hooks/useAuth';
import { useHasLocationScope } from 'hooks/useHasLocationScope';

// Grow/Elevate see Overview as "Channel Insights" under Reports once the new Location Home is on.
// Cuboh-only users have no location Reports section.
export const useIsChannelInsights = () => {
  const flags = useFlags();
  const { isUserCubohOnly } = useAuth();
  const hasAggregationScope = useHasLocationScope(RESTAURANT_ORDERS_AGGREGATION);

  return !!flags?.[FEATURE_FLAGS.rpDashAgent] && !isUserCubohOnly && hasAggregationScope;
};
